function clone(object) {
  try {
    return JSON.parse(JSON.stringify(object));
  } catch (e) {
    console.log(object);
    throw e;
  }
}
export {
  clone
};
//# sourceMappingURL=clone.js.map
